// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
let InlineWarning__Jsx3 = require("../../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let WithdrawForSalePropertyDialogMutation_graphql = require("../../../__generated__/WithdrawForSalePropertyDialogMutation_graphql.bs.js");

let convertVariables = WithdrawForSalePropertyDialogMutation_graphql.Internal.convertVariables;

let convertResponse = WithdrawForSalePropertyDialogMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = WithdrawForSalePropertyDialogMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, WithdrawForSalePropertyDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, WithdrawForSalePropertyDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let WithdrawForSalePropertyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function WithdrawForSalePropertyDialog(props) {
  let close = props.close;
  let propertyId = props.propertyId;
  let match = use();
  let mutate = match[0];
  let match$1 = React.useState(() => "");
  let setComment = match$1[1];
  let comment = match$1[0];
  let match$2 = React.useState(() => "Idle");
  let setSubmissionStatus = match$2[1];
  let submissionStatus = match$2[0];
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Withdraw property",
    isOpen: props.isOpen,
    ariaLabel: "Withdraw property",
    onDismiss: close,
    size: "Large",
    children: JsxRuntime.jsx("form", {
      children: JsxRuntime.jsxs(ViewStack.make, {
        children: [
          JsxRuntime.jsx("div", {
            children: "The property will no longer be active for new matches on TAN. The new TAN status and your comments will show to TAN members on existing matches."
          }),
          JsxRuntime.jsx(Form__TextAreaField.make, {
            labelText: "Comments",
            optionalText: "optional",
            onChange: evt => setComment(evt.target.value),
            value: comment
          }),
          ReactRender.ifTrue(JsxRuntime.jsx(InlineWarning__Jsx3.make, {
            children: "There was a problem withdrawing the property. Please try again."
          }), submissionStatus === "SubmissionError"),
          JsxRuntime.jsxs(ViewStack.make, {
            mt: "lg",
            space: "sm",
            justifyContent: "flexEnd",
            flexDirection: "row",
            children: [
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                onClick: param => close(),
                disabled: submissionStatus === "Loading",
                size: "medium",
                _type: "button",
                children: "Cancel"
              }),
              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                disabled: submissionStatus === "Loading",
                children: "Withdraw"
              })
            ]
          })
        ]
      }),
      onSubmit: event => {
        event.preventDefault();
        setSubmissionStatus(param => "Loading");
        mutate({
          input: {
            comments: Form__Helpers.opt_of_string(comment),
            id: propertyId
          }
        }, undefined, undefined, undefined, (param, param$1) => {
          let withdrawForSaleProperty = param.withdrawForSaleProperty;
          if (withdrawForSaleProperty === undefined) {
            return setSubmissionStatus(param => "SubmissionError");
          }
          if (withdrawForSaleProperty.__typename !== "ForSalePropertyWithdrawn") {
            return setSubmissionStatus(param => "SubmissionError");
          }
          close();
          setSubmissionStatus(param => "Idle");
          setComment(param => "");
        }, param => setSubmissionStatus(param => "SubmissionError"), undefined);
      }
    })
  });
}

let make = WithdrawForSalePropertyDialog;

exports.WithdrawForSalePropertyMutation = WithdrawForSalePropertyMutation;
exports.make = make;
/* commitMutation Not a pure module */
